module.exports = __webpack_public_path__ + "img/2-4.8e814c87.svg";